export default __webpack_public_path__ + "locales/zh-CN/Settings.json?hash=102b191800a9f7b38fdc1d71502aeec0";